import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import api, { IMAGE_BASE_URL } from "../../../api/Api.js";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./VisaAssistanceDetails.css";
import Swal from "sweetalert2";
const AddBlogPageDetails = () => {

  const imagePath = `${IMAGE_BASE_URL}/uploads/visa/`;

  const { pageID } = useParams();


const [getBlogLink, setBlogLink] = useState("");
const [title, setTitle] = useState("");
const [sbTitle, setSbTitle] = useState("");
const [description, setDescription] = useState("");
const [content, setContent] = useState("");
const [getBlogDate, setBlogDate] = useState("");
const [getCategory, setCategory] = useState("");
const [getMetaKey, setMetaKey] = useState("");
const [getMetaDescription, setMetaDescription] = useState("");
const [getKeyword, setKeyword] = useState("");
const [autherName, setAutherName] = useState("");
const [getblogdata, setblogdata] = useState([]);
   const [getSratingPrice, setSratingPrice] = useState("");
   const [getProcessTime, setProcessTime] = useState("");
   const [getHourDays, setHourdays] = useState("");
   const [getYoutubeLink, setYoutubeLink] = useState("");
  // FIXED STATE
  const [featured, setFeatured] = useState([]);
const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState(null);
  const [tabChecks, setTabChecks] = useState({});
const [tabContents, setTabContents] = useState({});
const [getFaq, setFaq] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  useEffect(() => {
    fetchBlogDataEdit();
    fetchVisaTabDetails();
    fetchFaqDetails();
  }, []);

const fetchBlogDataEdit = async () => {
  try {
    const res = await api.get(`/adminVisaAssistanc/getVisaDataEdit/${pageID}`);

    const data = res.data?.data || [];
// console.log(data);
    const blogLink = data[0]?.visaLink;
    const title = data[0]?.title;
    const sub_title = data[0]?.sub_title;
    const pageContent = data[0]?.pageContent;
    const description = data[0]?.description;
    const addedDt = data[0]?.addedDt;
    const pageimg = data[0]?.pageimg || "";
    const extraImages = data[0]?.extraImages || "[]"; 

    const metaKey = data[0]?.metaTitle;
    const metaDescription = data[0]?.metaDescription;
    const keyword = data[0]?.metaDescription;
  const category = data[0]?.country;
    setSratingPrice(data[0]?.sratingPrice);
    setProcessTime(data[0]?.processTime);
    setHourdays(data[0]?.hourDays);
       setHourdays(data[0]?.hourDays);
      setYoutubeLink(data.youTube_link || "");
    setblogdata(data);
    setCategory(category);
    setTitle(title);
    setSbTitle(sub_title);
    setDescription(description);
    setContent(pageContent);
    setBlogDate(addedDt);
    setBlogLink(blogLink);

    setMetaKey(metaKey);
    setMetaDescription(metaDescription);
    setKeyword(keyword);

    // SPLIT MAIN IMAGES
    const imageArray = pageimg ? pageimg.split(",") : [];

    setFeatured(imageArray);

    // =============================
    // SET EXTRA IMAGES FOR EDIT
    // =============================
    // extraImages comes as JSON string like:
    // '[{"image":"img1.jpg","altTitle":"title1"}, {"image":"img2.jpg","altTitle":"title2"}]'

    let extraImagesArray = [];
    try {
      // extraImagesArray = JSON.parse(extraImages).map(item => item.image, item => item.altTitle);
      extraImagesArray = JSON.parse(extraImages || "[]").map(item => ({
    image: item.image,
    altTitle: item.altTitle
  }));
    } catch (err) {
      console.error("Failed to parse extraImages:", err);
    }

    // Merge or set separately as needed
    setFeatured(prev => [...prev, ...extraImagesArray]); // merge with main images if needed

    console.log("Extra images loaded:", extraImagesArray);

  } catch (error) {
    toast.error("Failed to load blog data");
  }
};


const fetchVisaTabDetails = async () => {
  try {
  
 const res = await api.get(`/adminVisaAssistanc/getVisaTabDetailsAdmin/${pageID}`);
    const data = res.data?.data || [];
   setTabs(res.data?.data || []);

   } catch (error) {
    // console.log(error);
  
  }
}

  const fetchFaqDetails = async () => {
  try {
  
    const res = await api.get(`/adminVisaAssistanc/getFaqDetailsAdmin/${pageID}`);
    const data = res.data?.data || [];
   setFaq(res.data?.data || []);
   } catch (error) {
    // console.log(error);
  
  }
}

const removeTabRowInsert = async (tabId) => {


  const confirm = await Swal.fire({
    title: "Delete Tab?",
    icon: "warning",
    showCancelButton: true
  });

  if (!confirm.isConfirmed) return;
  try {
  
        const res = await api.delete(
          `/adminVisaAssistanc/deleteTabVisa/${tabId}`
        );
  
        if (res.data.success) {
          Swal.fire("Deleted!", "Tab deleted successfully", "success");
          window.location.reload();
        }
  
      } catch (error) {
        toast.error("Failed to delete Tab");
      }
};

return (
  <div className="container-fluid py-4 bg-light min-vh-100">

    {/* Header */}

    <div className="card border-0 shadow-sm mb-4">
      <div className="card-body d-flex justify-content-between align-items-center">

        <div>
          <h3 className="fw-bold mb-0">
            Visa Assistance Details
          </h3>

          <small className="text-muted">
            View complete Visa Assistance information
          </small>
        </div>

        <Link
          to="/visa-assistance-manage"
          className="btn btn-outline-dark d-flex align-items-center gap-2"
        >
          <ArrowLeft size={18} />
          Back
        </Link>

      </div>
    </div>

    <div className="row justify-content-center">

      <div className="col-lg-12">
   <div className="mb-3">

              <span className="badge bg-primary px-3 py-2">

                <i className="fa fa-link me-2"></i>

                {getBlogLink}

              </span>

            </div>

            {/* Title */}

            <h1 className="fw-bold mb-2 blog-title">
              {title}
            </h1>

            {/* Subtitle */}

            <h5 className="text-muted mb-4">
              {sbTitle}
            </h5>
        <div className="card border-0 shadow-sm overflow-hidden">

          {/* Carousel */}

          <div
            id="featuredCarousel"
            className="carousel slide"
            data-bs-ride="carousel"
          >

            {featured.length > 1 && (
              <div className="carousel-indicators">

                {featured.map((_, index) => (
                  <button
                    key={index}
                    type="button"
                    data-bs-target="#featuredCarousel"
                    data-bs-slide-to={index}
                    className={
                      index === 0 ? "active" : ""
                    }
                  ></button>
                ))}

              </div>
            )}

            <div className="carousel-inner">

              {featured.map((item, index) => (

                <div
                  key={index}
                  className={`carousel-item ${
                    index === 0 ? "active" : ""
                  }`}
                >

                  <img
                    src={`${imagePath}${item.image}`}
                    alt={item.altTitle}
                    title={item.altTitle}
                    className="w-100 blog-banner-image"
                  />

                </div>

              ))}

            </div>

            {featured.length > 1 && (
              <>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#featuredCarousel"
                  data-bs-slide="prev"
                >
                  <span className="carousel-control-prev-icon"></span>
                </button>

                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#featuredCarousel"
                  data-bs-slide="next"
                >
                  <span className="carousel-control-next-icon"></span>
                </button>
              </>
            )}

          </div>

          {/* Content */}

          <div className="card-body p-4 p-lg-5">

            {/* Blog Link */}

         
{/* category and tag section start */}
  <div className="card bg-light border-0 mb-4">

              <div className="card-body">


                <p className="mb-2">
                  <strong>Country :</strong>
                  {" "}
                   {getCategory
    ?.replace(/-/g, " ")
    ?.replace(/\b\w/g, (char) => char.toUpperCase())
  }
                  
                </p>


     <p className="mb-2">
                  <strong>Starting Price :</strong>
                  {" "}
                   {getSratingPrice}
      </p>


      <p className="mb-2">
                  <strong>Processing Time :</strong>
                  {" "}
                   {getProcessTime} {getHourDays}
                  
      </p>

       <p className="mb-2">
                  <strong>You Tube Link :</strong>
                  {" "}
                   {getYoutubeLink}
                  
      </p>
           

             

              </div>

            </div>
{/* category and tag section end */}
{/* SEO Section */}

            <div className="card bg-light border-0 mb-4">

              <div className="card-body">

                <h5 className="fw-bold mb-3">
                  SEO Information
                </h5>

                <p className="mb-0">
                  <strong>Meta Title:</strong>
                  {" "}
                  {getMetaKey}
                </p>

                <p className="mb-0">
                  <strong>
                    Meta Description:
                  </strong>
                  {" "}
                  {getMetaDescription}
                </p>

                <p className="mb-0">
                  <strong>
                    Meta Keyword:
                  </strong>
                  {" "}
                  {getKeyword}
                </p>

              </div>

            </div>
            {/* Description */}

            <div className="blog-description mb-4">

              <p  style={{marginTop:"1px",textAlign:"justify"}}>{description}</p>

            </div>

            

            {/* Main Content */}

            <div
              className="blog-content"
              dangerouslySetInnerHTML={{
                __html: content
              }}
            ></div>
{/* TAB DATA SHOW AREA START */}
 <div>
      {/* Tabs */}
      <ul className="nav nav-tabs">
    
           {tabs.map((tab) => {
  if (tab.content !== "") {
    return (
          <li
            key={tab.id}
     className={`custom-tab ${
    activeTab === tab.id ? "tab-active" : "tab-inactive"
  }`}
            style={{ display: "inline-block" }}
          >
            <button
             onClick={() => setActiveTab(tab.id)}
              style={{
                border: "none",
                background: "none",
                cursor: "pointer",
                padding: "5px",
              }}
            >
              {tab.tab_name}
            </button>
            <button type="button" className="btn btn-danger btn-sm mr-2"
            onClick={() => removeTabRowInsert(tab.id)}
            style={{margin:"4px"}}
            >
              
              <i class="fa fa-trash-o" aria-hidden="true"></i></button>
          </li>
       );
  }

  return null;
})}
      </ul>

      {/* Tab Content */}
        {/* Dynamic Content */}
      <div className="tab-content">
        {tabs.map((tab) =>
        
          activeTab === tab.id ? (
            
            <div key={tab.id}>
              <div  style={{display:"flex",backgroundColor:"#ff6c26",color:"#fff",fontWeight:"600",paddingLeft:"5px"}}>
            
              <p style={{marginLeft:"5px",marginTop:"1px"}}>{tab.tab_name}</p>
         
      </div>
<div
  style={{
    marginTop: "5px",
    lineHeight: "1.6"
  }}
  dangerouslySetInnerHTML={{ __html: tab.content }}
></div>
            </div>
          ) : null
        )}
      </div>
    </div>
{/* TAB DATA SHOW AREA END */}
  {/* faq area atart */}
<div className="mt-3">
     {/* <pre>
      {JSON.stringify(getFaq, null, 2)}
    </pre> */}
{getFaq && getFaq.length > 0 && (
    <div className="faq-container">
      <h2 className="faq-title">Frequently Asked Questions</h2>

      {getFaq.map((item, index) => (
        <div key={index} className="faq-item">
          
          <div className="faq-question" onClick={() => toggle(index)}>
            <span>{item.ques}</span>
            <span className="icon">
              {activeIndex === index ? "−" : "+"}
            </span>
          </div>

          <div
            className={`faq-answer ${
              activeIndex === index ? "open" : ""
            }`}
          >
            <p>{item.ans}</p>
          </div>

        </div>
      ))}
    </div>
    )}
</div>
{/* faq area end */}

          </div>

        </div>

      </div>

    </div>

  </div>
);
};

export default AddBlogPageDetails;